import script from "./SliderAwards.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderAwards.vue?vue&type=script&setup=true&lang=js"

import "./SliderAwards.vue?vue&type=style&index=0&id=f80996d6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f80996d6"]])

export default __exports__